const PLACES_RESPONSE = [
  {
    id: 'AGODA_CITY|21241',
    name: 'Osasco',
    description: 'Osasco, Brazil',
    latitude: -23.566668,
    longitude: -46.783333,
  },
];

const GEOLOCATION_RESPONSE = {
  lstAddress: [
    {
      country: {
        longName: 'Brasil',
        shortName: 'BR',
      },
      federatedUnit: {
        longName: 'Minas Gerais',
        shortName: 'MG',
      },
      city: {
        longName: 'Belo Horizonte',
        shortName: 'Belo Horizonte',
      },
      neighborhood: {
        longName: 'Cruzeiro',
        shortName: 'Cruzeiro',
      },
      street: null,
      zipCode: {
        longName: '30310-110',
        shortName: '30310-110',
      },
      formattedAddress: 'Cruzeiro, Belo Horizonte - MG, 30310-110, Brasil',
      placeID: 'ChIJZbbk88eZpgARvvSfTZ2pThI',
    },
  ],
};

const DETAIL_RESPONSE = {
  country: {
    longName: 'Brasil',
    shortName: 'BR',
  },
  federatedUnit: {
    longName: 'São Paulo',
    shortName: 'SP',
  },
  city: {
    longName: 'Barueri',
    shortName: 'Barueri',
  },
  neighborhood: {
    longName: 'Alphaville Industrial',
    shortName: 'Alphaville Industrial',
  },
  street: {
    longName: 'Alameda Rio Negro',
    shortName: 'Alameda Rio Negro',
  },
  zipCode: {
    longName: '06454-000',
    shortName: '06454-000',
  },
  formattedAddress:
    'Alameda Rio Negro - Alphaville Industrial, Barueri - SP, 06454-000, Brasil',
  placeID: 'ChIJFR-lEyMCz5QRjWFy92Z4498',
};

const AUTOCOMPLETE_RESPONSE = [
  {
    address: 'Rua Ouro Fino - Cruzeiro, Belo Horizonte - MG, Braaaaasil',
    placeID:
      'EjJBdi4gUGF1bGlzdGEgLSBCZWxhIFZpc3RhLCBTw6NvIFBhdWxvIC0gU1AsIEJyYXNpbCIuKiwKFAoSCRWjCtrIWc6UEWp3yfIxlJ_VEhQKEglhPUZWt1nOlBFkCfT35tHzCQ',
  },
];

export default {
  PLACES_RESPONSE,
  GEOLOCATION_RESPONSE,
  DETAIL_RESPONSE,
  AUTOCOMPLETE_RESPONSE,
};
